import createPlugin from './createPlugin';
import ReusableHtmlRenderer from './Renderer/ReusableHtmlRenderer';
import { lazyLoad } from '@react-page/editor';
const ReusableDefaultControls = lazyLoad(() => import('./Controls/Controls'));
export default (settings) => {
    const plugin = createPlugin(Object.assign({ Controls: ReusableDefaultControls, Renderer: ReusableHtmlRenderer }, settings));
    return plugin;
};
//# sourceMappingURL=index.js.map